import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SectionService } from "../../../../services/help/section.service";
import { Section } from '@app/models/help/section.model';
import swal from "sweetalert";
import {ToastrService} from "ngx-toastr";
import {clonify} from "@app/shared/utils/object.utils";

@Component({
    selector: 'app-section',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.scss']
})
export class SectionComponent {
    @Input()
    public sections: Section[];

    @Output()
    public sectionsChanged = new EventEmitter();


    public isFormOpen: boolean = false;
    public sectionFormGroup: FormGroup;

    public section: Section = new Section();
    public isInUpdateMode: boolean = false;

    constructor(private formBuilder: FormBuilder,
        private toasterService: ToastrService,
        private sectionService: SectionService) {
        this.createFormGroup();
    }

    public createFormGroup() {
        this.sectionFormGroup = this.formBuilder.group({
            title: [null, Validators.required]
        });
    }

    public bindSections() {
      this.sectionService.getList().subscribe(result => {
            this.sections = <Section[]>(result);
            this.sectionsChanged.emit(this.sections);
        });

    }

    public newSection() {
        this.isFormOpen = !this.isFormOpen;
    }

    public submitForm(form) {
        if (!this.sectionFormGroup.valid) {
            return;
        }

      this.section = { ...this.section, ...this.sectionFormGroup.value };

        var process;
        if (this.isInUpdateMode) {
            process = this.sectionService.update(this.section);
        } else {
            process = this.sectionService.insert(this.section);
        }

        process.subscribe(() => {
            this.bindSections();
            this.clearForm(form);
        });
        this.isInUpdateMode = false;
        this.toasterService.success('Record is updated.', 'Section');
    }

    public clearForm(form) {
        this.section = new Section();
        this.sectionFormGroup.reset();
        form.resetForm();
    }

    public edit(section) {
        this.isFormOpen = true;
        this.section = clonify(section);
        this.sectionFormGroup.patchValue(this.section);
        this.isInUpdateMode = true;
    }

    public delete(id) {
        swal({
            title: 'Are you sure?',
            text: '',
            icon: 'warning',
          buttons: {
            cancel: {
              text: 'No, cancel please!',
              visible: true,
              closeModal: true
            },
            confirm: {
              text: 'Yes, delete it!',
              value: true,
              visible: true,
              className: 'bg-danger',
              closeModal: true
            }
          }
        }).then((isConfirm) => {
          if (isConfirm) {
            this.sectionService.delete(id).subscribe(() => {
              this.bindSections();
              this.toasterService.info('Record is deleted.', 'Section');
            });
          }
        });
    }
}
